import React from 'react'
import { Dialog } from 'primereact/dialog'
import { BtnIcon, InputText, Loading } from '../../../../components'
import { FaSave, FaTrashAlt } from 'react-icons/fa'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { connect } from 'react-redux'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import * as EnderecamentoHttp from '../../../../services/api/https/deliveries/enderecamento-entregas.http'

function ModalEditEnderecoEntrega({ entrega, visible, onClose, dispatch }) {
  // Vars
  const INIT_STATE = {
    novoEndereco: '',
    isLoading: false,
    entregaSelecionada: undefined,
    enderecos: [],
  }
  // Hooks
  const [state, setState] = React.useState(INIT_STATE)
  React.useEffect(() => {
    setState(prevState => {
      if (typeof entrega === 'object') {
        prevState.entregaSelecionada = entrega
        const enderecamento = entrega.endereco_estoque
        if (enderecamento) {
          const enderecos = enderecamento.split(';')
          if (Array.isArray(enderecos)) {
            prevState.enderecos = enderecos
          } else {
            prevState.enderecos = [enderecamento]
          }
        } else {
          prevState.enderecos = []
        }
      }
      return { ...prevState }
    })
  }, [entrega])

  // Events
  const onBtnSalvarClick = async () => {
    try {
      if (state.novoEndereco.trim().length === 0) throw new Error('Endereço incorreto.')
      setState({ ...state, isLoading: true })
      await EnderecamentoHttp.salvarEnderecamentoDaEntrega(
        state.entregaSelecionada.delivery_id,
        state.novoEndereco,
      )
      setState({
        ...state,
        isLoading: false,
        enderecos: [...state.enderecos, state.novoEndereco],
        novoEndereco: '',
      })
    } catch (e) {
      setState({ ...state, isLoading: false })
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  const onExcluirClick = async endereco => {
    try {
      await EnderecamentoHttp.apagarEnderecamentoDaEntrega(
        state.entregaSelecionada.delivery_id,
        endereco,
      )
      setState({ ...state, enderecos: state.enderecos.filter(e => e !== endereco) })
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  const onModalClose = () => {
    const e = { ...state.entregaSelecionada }
    e.endereco_estoque = state.enderecos.join(';')
    onClose(e)
  }

  // Helpers

  // Render
  return (
    <Dialog
      header={state.enderecos.length > 0 ? 'Editando Endereços' : 'Adicione Endereço'}
      visible={visible}
      onHide={onModalClose}
      style={{ width: 400 }}
    >
      <div className="p-grid">
        <div className="p-col-12">
          <div className="p-grid">
            <div className="p-col-10">
              <InputText
                marginTop={0}
                label={'Novo Endereço de Estoque:'}
                value={state.novoEndereco}
                onChange={value => setState({ ...state, novoEndereco: value })}
              />
            </div>
            <div className="p-col-2" style={{ paddingTop: 27 }}>
              {state.isLoading ? (
                <div>
                  <Loading />
                </div>
              ) : (
                <BtnIcon onClick={onBtnSalvarClick}>
                  <FaSave size={24} color={'#14B0BF'} />
                </BtnIcon>
              )}
            </div>
          </div>
        </div>
        <div className="p-col-12">
          <DataTable
            value={state.enderecos}
            emptyMessage={'Não existe endereço de estoque associado a esta entrega'}
            paginator={true}
            rows={5}
          >
            <Column
              header={'#'}
              body={endereco => (
                <BtnIcon onClick={() => onExcluirClick(endereco)}>
                  <FaTrashAlt color={'red'} size={16} />
                </BtnIcon>
              )}
              style={tableCellCentered(60)}
            />
            <Column header={'Endereço'} body={endereco => endereco} />
          </DataTable>
        </div>
      </div>
    </Dialog>
  )
}

export default connect()(ModalEditEnderecoEntrega)
